// extracted by mini-css-extract-plugin
module.exports = {"signUpForm":"SignUpForm_signUpForm__2olly","signUpButton":"SignUpForm_signUpButton__27RfJ","errorCard":"SignUpForm_errorCard__fxVJV","helperText":"SignUpForm_helperText__1X4tj"};